import { Chip, SxProps, Theme } from '@mui/material';

import { appStrings } from '../assets/appStrings';

const STRINGS = appStrings.modules.emulationChip;

export const EmulationChip = () => (
  <Chip variant="tag" size="sm" label={STRINGS.label} sx={chipSx} />
);

const chipSx: SxProps<Theme> = ({ backrs }) => ({
  width: 'fit-content',
  flexShrink: 0,
  border: `1px solid ${backrs.colors['Colors/Foreground/fg-success-secondary']}`,
  backgroundColor: backrs.colors['Colors/Background/bg-success-primary'],
  '& .MuiChip-label': {
    color: backrs.colors['Colors/Text/text-success-primary'],
  },
});
